import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import AllowedUsers from "../AllowedUsers";
import Waitlist from "../Waitlist";

export default function Access() {
  return (
    <TabbedGroup
      tabs={[
        { value: "allowed", label: "Allowed Users", permission: AP.MANAGE_USERS, element: <AllowedUsers /> },
        { value: "waitlist", label: "Waitlist", permission: AP.MANAGE_USERS, element: <Waitlist /> },
      ]}
    />
  );
}
